export default "__VITE_ASSET__CDNBLoxl__"